const backendUrl = "https://lariales-back.herokuapp.com";

export default backendUrl;